import { ProductService } from '../../providers/product/product.service';
import { Component } from '@angular/core';
import { IngredientService } from '../../providers/ingredient/ingredient.service';
import { OrdersService } from '../../providers/order/orders.service';
import { NavParams, ViewController, ToastController } from 'ionic-angular';
import { forkJoin } from 'rxjs/observable/forkJoin';
@Component({
    selector: 'personalize-product',
    templateUrl: 'personalize-product.html',
    providers: [ProductService, IngredientService]
})
export class PersonalizeProductComponent {
    product: any = {};
    host = "";
    filterOpt = "";
    filterSupp = "";
    unavComp = 0;
    unavSupp = 0;
    unavOpt = 0;
    optChecked: number = 0;
    mobilecheck: boolean;
    loadAvatar = false;
    itemExpandHeight: number = 100;
    k = -1;
    loading = true;
    m: number = 0;
    currency = "€";
    language = localStorage.getItem('language');
    constructor(
        private productService: ProductService,
        private ingredientsService: IngredientService,
        private orderService: OrdersService,
        params: NavParams,
        public viewCtrl: ViewController,
        private toastCtrl : ToastController
    ) {
        this.currency = localStorage.getItem('currency');
        this.optChecked = 0;
        this.product = params.get('product');
    }
    ngOnInit() {
        setTimeout(
            () => {
                forkJoin([this.getCompositions(),
                this.getOptions(),
                this.getSupplements(),
                this.getOptionsObligatoir()]).subscribe(
                    (data: any[]) => {
                        this.loading = false;
                        this.product.compositions = data[0].map(p => {
                            p.label = p.text;
                            p.checked = true
                            return p;
                        })
                        this.unavComp = this.product.compositions.filter(comp => comp.disabled == 'true').length;
                        this.product.optionIngredients = data[1].map(p => {
                            p.label = p.text;
                            return p;
                        })
                        this.unavOpt = this.product.optionIngredients.filter(opt => opt.disabled == 'true').length;
                        this.product.selectedOpt = [];
                        this.product.supplements = data[2].map(p => {
                            p.label = p.text;
                            return p;
                        })
                        this.unavSupp = this.product.supplements.filter(supp => supp.disabled == 'true').length;
                        this.product.selectedSupp = [];
                        this.product.obligatoryIngredient = [];
                        this.product.obligatoryIngredient = data[3];
                    }
                )
            }, 100
        )
    }
    getCompositions() {
        return this.productService.getProductCompositions(this.product.id);
    }
    getOptions() {
        return this.productService.getProductOptionsIngredient(this.product.id);
    }
    getSupplements() {
        return this.productService.getProductSupplements(this.product.id);
    }
    getOptionsObligatoir() {
        return this.ingredientsService.getObligatoryIngredientOfProduct(this.product.id);
    }
    expandItem(i) {
        this.k = (this.k == i) ? -1 : i;
    }

    displayMessage(message) {
        let toast = this.toastCtrl.create({
          message: message,
          duration: 3000,
          position: 'top'
        });
        toast.present();
      }
    addToBasket() {
        let error = 0;
        let product = JSON.parse(JSON.stringify(this.product));
        if (!(product.size >= 0)) {
            error++;
            if(this.language == "eng"){
                this.displayMessage('Product unavailable for the moment')
            }
            if(this.language == "fr"){
            this.displayMessage('Produit indisponible pour le moment')
            }
            return;
        }
        if (product.custom) {
            product.selectedOpt = this.product.optionIngredients.filter(c => c.disabled == "false" && c.checked);
            if (product.selectedOpt.length == 0) {
                error++;
                if(this.language == "eng"){
                    this.displayMessage('Please add options');
                }
                if(this.language == "fr"){
                this.displayMessage('Merci d\'ajouter les options');
                }
                return;
            } else {
                product.obligatoryIngredient.forEach(cat => {
                    let array = product.selectedOpt.filter(o => o.category == cat.id);
                    if (error==0 && array.length < cat.maxNbrIngOptions) {
                        error++;
                        if(this.language == "eng"){
                            this.displayMessage('Please select at least \r\n' + cat.maxNbrIngOptions + ' ingredient(s) of the category ' + cat.category);
                        }
                        if(this.language == "fr"){
                        this.displayMessage('Merci de selectionner au moins \r\n' + cat.maxNbrIngOptions + ' ingredient(s) de la categorie ' + cat.category);
                        }
                        return;
                    }
                });
            }
        }
        if (error == 0) {
            let element = {
                id: this.product.id,
                code: this.product.code,
                name: this.product.name,
                family: this.product.family,
                size: this.product.sizes[this.product.size],
                comment: (this.product.comment) ? this.product.comment : '',
                qty: Number(this.product.qty),
                removedCompositions: this.product.compositions.filter(c => c.disabled == "false" && !c.checked),
                supplements: [],
                optionIngredients: this.product.optionIngredients.filter(c => c.disabled == "false" && c.checked),
                total: 0,
                vat: this.product.vat,
                priceSuppApp: this.product.priceSuppApp,
                priceWithSupp: Number(this.product.sizes[this.product.size].price),
                maxNbrIngOptions: this.product.maxNbrIngOptions,
                hasSupp: this.product.hasSupp
            }
            this.product.selectedSupp = this.product.supplements.filter(c => c.disabled == "false" && c.checked);
            element.total += Number(element.size.price);
            if (this.product.selectedSupp && this.product.selectedSupp.length > 0) {
                switch (Number(this.product.priceSuppApp)) {
                    case 1: {
                        element['supplements'] = (this.product.selectedSupp) ? this.product.selectedSupp : [];
                        if (element.supplements.length > 0) {
                            element.supplements.forEach((ele, index, array) => {
                                let el = JSON.parse(JSON.stringify(ele));
                                element.total += Number(el.price);
                                if (index == array.length - 1) {
                                    this.addElementToOrder(element)
                                }
                            });
                        } else {
                            this.addElementToOrder(element)
                        }
                        break;
                    }
                    case 2: {
                        let arraRquest = [];
                        this.product.selectedSupp.forEach(ele => {
                            arraRquest.push(this.ingredientsService.getIngredientsCatFamSizeBySize(ele.category, this.product.family, element.size.idSize))
                        });
                        forkJoin(arraRquest).subscribe(
                            (d) => {
                                d.forEach((data : any, index, array) => {
                                    let el = JSON.parse(JSON.stringify(this.product.selectedSupp[index]));
                                    if (data.length > 0) {
                                        el.price = Number(data[0].price);
                                    }
                                    element.supplements.push(el);
                                    element.total += +el.price;
                                    if (array.length - 1 == index) {
                                        this.addElementToOrder(element)
                                    }
                                })
                            }
                        )
                        break;
                    }
                    case 3: {
                        this.product.selectedSupp.forEach((ele, index, array) => {
                            let el = JSON.parse(JSON.stringify(ele));
                            el.price = Number(element.size.priceSupp)
                            element.supplements.push(el)
                            element.total += el.price;
                            if (index == array.length - 1) {
                                this.addElementToOrder(element)
                            }
                        });
                        break;
                    }
                }
            } else {
                this.addElementToOrder(element);
            }
        }
    }
    changeOption(opt) {
        if (opt.checked) {
            this.optChecked++;
        } else {
            this.optChecked--;
        }
    }
    incrQty() {
        this.product.total += this.product.total / this.product.qty;
        this.product.qty++;
    }
    decrQty() {
        if (this.product.qty > 1) {
            this.product.total -= this.product.total / this.product.qty;
            this.product.qty--;
        }
    }
    addElementToOrder(element) {
        element.total *= Number(element.qty);
        this.orderService.addElementToOrder(element);
        this.viewCtrl.dismiss();
        //this.bsModalRef.hide();
    }
    closeModal() {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/components/personalize-product/personalize-product.ts